import { ChangeDetectionStrategy, Component, computed, effect, Signal, signal, untracked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ProductCategoryReportMultiSelectComponent } from '../../../product';
import { ReportParameterBase } from './report-parameter-base';

@Component({
    selector: 'app-product-category-report-multi-select-parameter',
    imports: [ProductCategoryReportMultiSelectComponent],
    template: `
        <app-product-category-report-multi-select
            [selectedProductCategoryReportKeys]="productCategoryReportKeys()"
            [id]="parameterDefinition().key"
            [subscriberKey]="subscriberKey()"
            [placeHolder]="subscriberKey() != null ? parameterDefinition().placeholder : 'Select a subscriber first'"
            [invalid]="isInvalid()"
            [disabled]="isDisabled()"
            (blur)="onBlur()"
            (loadingChange)="onLoadingChange($event)"
            (selectedProductCategoryReportKeysChange)="onProductCategoryReportKeysChange($event)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ProductCategoryReportMultiSelectParameterComponent,
            multi: true
        }
    ]
})
export class ProductCategoryReportMultiSelectParameterComponent extends ReportParameterBase<number[]> {
    productCategoryReportKeys = signal<number[]>([]);
    subscriberKey: Signal<number | null> = this.reportWorkspace.subscriberKey;

     override isDisabled = computed(() => this.reportWorkspace.isReportRunning() || this.isFormControlDisabled() || !this.subscriberKey());

    constructor() {
        super();

        /* Clear Options when Subscriber Changes */
        effect(() => {
            this.subscriberKey();
            const parameterDefinition = untracked(this.parameterDefinition);

            if (!this.isInitialized) {
                return;
            }

            const value = (parameterDefinition.emptyValue as number[]) ?? [];

            this.productCategoryReportKeys.set(value);
            this.reportWorkspace.setParam(parameterDefinition.key, value);
            this.onChange(value);

            this.formControl?.markAsUntouched();
            this.formControl?.markAsPristine();
        });
    }

    onProductCategoryReportKeysChange(productCategoryReportKeys: number[]) {
        this.productCategoryReportKeys.set(productCategoryReportKeys);

        this.reportWorkspace.setParam(this.parameterDefinition().key, productCategoryReportKeys);

        this.onChange(productCategoryReportKeys);
        this.markTouchedIfNotResetting();
    }

    onLoadingChange(loading: boolean) {
        this.reportWorkspace.setParamLoading(this.parameterDefinition().key, loading);
    }

    onBlur() {
        this.onTouched();
    }

    // CVA callbacks
    writeValue(obj: number[]): void {
        this.productCategoryReportKeys.set(obj);
    }
}
